// extracted by mini-css-extract-plugin
module.exports = {"group":"BuildingObjectsPicker_group__OjopM","active":"BuildingObjectsPicker_active__yGLmX"};